// Ministry data — used by the ministries landing page and detail pages
import {
  HandHelping,
  Baby,
  Sparkles,
  Video,
} from 'lucide-react';

export const ministries = [
  {
    slug: 'outreach',
    name: 'Outreach',
    tagline: 'Bringing the love of Christ beyond our walls.',
    short:
      'Serving our neighbors through practical care, evangelism, and community events \u2014 sharing hope where it\u2019s needed most.',
    icon: HandHelping,
    giveFund: 'Outreach',
    image:
      'https://customer-assets-lxgj4vgw.emergentagent.net/job_laughing-proskuriakova-15/artifacts/tjgg1rti_outreach.webp',
    heroImage:
      'https://customer-assets-lxgj4vgw.emergentagent.net/job_laughing-proskuriakova-15/artifacts/tjgg1rti_outreach.webp',
    intro:
      "Outreach is the heartbeat of ACT beyond our Sunday services. We believe the Gospel is best lived out in the streets, homes, and neighborhoods of Gilroy. From food drives and community events to prayer walks and evangelism nights, this ministry exists to bring hope, dignity, and the love of Jesus to the people around us.",
    what: [
      'Community outreach events throughout the year',
      'Food and clothing distribution to families in need',
      'Prayer walks in the neighborhoods around our campus',
      'Evangelism training and mission opportunities',
    ],
    who: 'Anyone with a heart to serve \u2014 no experience required. Whether you can give one Saturday or every week, there\u2019s a place for you.',
    verse: {
      text:
        '\u201cLet your light so shine before men, that they may see your good works, and glorify your Father which is in heaven.\u201d',
      ref: 'Matthew 5:16',
    },
  },
  {
    slug: 'act-children',
    name: 'ACT Children',
    tagline: 'Where every child is loved, known, and led to Jesus.',
    short:
      'A safe, joyful, Bible-focused environment where kids build a foundation of faith through worship, teaching, and fun.',
    icon: Baby,
    image:
      'https://customer-assets-lxgj4vgw.emergentagent.net/job_laughing-proskuriakova-15/artifacts/ydgr3smu_IMG_6554.webp',
    heroImage:
      'https://customer-assets-lxgj4vgw.emergentagent.net/job_laughing-proskuriakova-15/artifacts/ydgr3smu_IMG_6554.webp',
    intro:
      'ACT Children exists to partner with families in raising the next generation to know and love Jesus. Every Sunday, our kids experience age-appropriate worship, engaging Bible lessons, and caring leaders who help them take their next step of faith.',
    what: [
      'Age-appropriate classes for nursery through elementary',
      'Worship, Bible stories, memory verses, and fun activities',
      'Safe, background-checked leaders in every classroom',
      'Special events like VBS, family nights, and holiday celebrations',
    ],
    who: 'Kids from newborn through 5th grade. First-time families are welcomed at the ACT Children check-in table \u2014 we\u2019ll walk you through everything.',
    verse: {
      text:
        '\u201cTrain up a child in the way he should go: and when he is old, he will not depart from it.\u201d',
      ref: 'Proverbs 22:6',
    },
  },
  {
    slug: 'reach-youth',
    name: 'Reach Youth Ministry',
    tagline: 'A generation set apart, reaching a generation.',
    short:
      'Middle and high school students growing in faith, friendship, and the pursuit of Jesus in real, everyday life.',
    icon: Sparkles,
    image:
      'https://customer-assets-lxgj4vgw.emergentagent.net/job_laughing-proskuriakova-15/artifacts/u8qthotu_ACTYT.webp',
    heroImage:
      'https://customer-assets-lxgj4vgw.emergentagent.net/job_laughing-proskuriakova-15/artifacts/u8qthotu_ACTYT.webp',
    intro:
      'Reach Youth Ministry is where middle and high school students at ACT go deeper in their walk with Jesus. Through worship, honest teaching, and life-giving friendships, we\u2019re raising up a generation that lives out their faith boldly in school, at home, and in their communities.',
    what: [
      'Weekly youth services with worship, teaching, and hangout time',
      'Small groups where students can be real and grow together',
      'Retreats, camps, and outreach trips throughout the year',
      'Mentorship from trusted adult leaders who show up consistently',
    ],
    who: 'Students in 6th through 12th grade. Come as you are \u2014 bring a friend. We meet weekly and love first-timers.',
    verse: {
      text:
        '\u201cLet no man despise thy youth; but be thou an example of the believers, in word, in conversation, in charity, in spirit, in faith, in purity.\u201d',
      ref: '1 Timothy 4:12',
    },
  },
  {
    slug: 'media',
    name: 'Media',
    tagline: 'Telling the ACT story with excellence.',
    short:
      'From livestream to photography, video, and audio \u2014 we use creative gifts to amplify what God is doing at ACT.',
    icon: Video,
    image:
      'https://customer-assets-lxgj4vgw.emergentagent.net/job_laughing-proskuriakova-15/artifacts/h63kg49w__M6A6724%20%281%29.webp',
    heroImage:
      'https://customer-assets-lxgj4vgw.emergentagent.net/job_laughing-proskuriakova-15/artifacts/h63kg49w__M6A6724%20%281%29.webp',
    intro:
      'The Media ministry captures and shares what God is doing at ACT. Every livestream, sermon clip, and photo is a chance to reach someone who isn\u2019t here yet. If you love creativity and technology, this is where your gifts meet the mission.',
    what: [
      'Weekly livestream production for Sunday and midweek services',
      'Photography and video for events and social media',
      'Sermon editing, subtitles, and podcast production',
      'Slides, lyrics, and worship service graphics',
    ],
    who: 'Anyone with an interest in creative or technical media \u2014 beginner or pro. We\u2019ll train you on our gear and workflow.',
    verse: {
      text:
        '\u201cAnd whatsoever ye do, do it heartily, as to the Lord, and not unto men.\u201d',
      ref: 'Colossians 3:23',
    },
  },
];
